import React from "react";

export default function BlackFridayOffer() {
  return null; // placeholder - not shown by default
}
